var map = {
	"./banner_bg.svg": 85,
	"./banner_bg_right.svg": 86,
	"./banner_img.png": 87,
	"./countdown_bg.png": 88,
	"./icon-facebook.svg": 13,
	"./icon-instagram.svg": 14,
	"./icon-linkedin.svg": 15,
	"./icon_1.svg": 89,
	"./icon_10.svg": 90,
	"./icon_2.svg": 91,
	"./icon_3.svg": 92,
	"./icon_4.svg": 93,
	"./icon_5.svg": 94,
	"./icon_6.svg": 95,
	"./icon_7.png": 96,
	"./icon_8.png": 97,
	"./icon_9.svg": 11,
	"./logo.svg": 8,
	"./open.png": 98,
	"./partners/campus_1.png": 16,
	"./partners/campus_10.png": 17,
	"./partners/campus_11.jpg": 18,
	"./partners/campus_13.jpeg": 19,
	"./partners/campus_14.jpg": 20,
	"./partners/campus_15.png": 21,
	"./partners/campus_17.jpg": 22,
	"./partners/campus_18.png": 23,
	"./partners/campus_19.png": 24,
	"./partners/campus_2.png": 25,
	"./partners/campus_20.jpeg": 26,
	"./partners/campus_21.png": 27,
	"./partners/campus_22.png": 28,
	"./partners/campus_23.png": 29,
	"./partners/campus_24.jpg": 30,
	"./partners/campus_25.png": 31,
	"./partners/campus_26.png": 32,
	"./partners/campus_27.png": 33,
	"./partners/campus_28.png": 34,
	"./partners/campus_29.png": 35,
	"./partners/campus_30.jpg": 36,
	"./partners/campus_31.png": 37,
	"./partners/campus_32.jpg": 38,
	"./partners/campus_5.png": 39,
	"./partners/campus_7.png": 40,
	"./partners/campus_9.png": 41,
	"./partners/school_1.png": 42,
	"./partners/school_10.png": 43,
	"./partners/school_11.jpg": 44,
	"./partners/school_12.png": 45,
	"./partners/school_13.png": 46,
	"./partners/school_14.png": 47,
	"./partners/school_2.png": 48,
	"./partners/school_3.JPG": 49,
	"./partners/school_4.jpg": 50,
	"./partners/school_5.png": 51,
	"./partners/school_6.png": 52,
	"./partners/school_7.jpg": 53,
	"./partners/school_8.jpg": 54,
	"./partners/school_9.png": 55,
	"./partners/shopee_logo.png": 56,
	"./partners/supporting_1.png": 57,
	"./partners/supporting_2.png": 58,
	"./partners/supporting_3.png": 59,
	"./partners/training_1.png": 60,
	"./students.png": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;